import { InfoRounded } from '@mui/icons-material'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { selectField } from '../../selectors'
import { setAction } from '../../slice'
import type { FieldAction, FieldName } from '../../types'

type Props = {
  fieldName: FieldName
}

const ActionDescription = () => (
  <>
    <div>
      Append: <div>New data will be included with existing data.</div>
    </div>
    <br />
    <div>
      Replace: <div>Overwrite existing with selected.</div>
    </div>
  </>
)

export default function ActionSelect({ fieldName }: Props) {
  const field = useAppSelector(selectField(fieldName))
  const dispatch = useAppDispatch()

  const handleChange = (_event: React.ChangeEvent, value: string) => {
    dispatch(setAction({ fieldName, fieldAction: value as FieldAction }))
  }

  if (field.fieldAction === undefined) return

  const options = ['Append', 'Replace'].map((option) => {
    return (
      <FormControlLabel
        key={`${fieldName}-${option}`}
        label={option}
        value={option.toLowerCase()}
        control={<Radio />}
      />
    )
  })

  return (
    <FormControl>
      <FormLabel id={`${fieldName}-fieldAction`}>
        <Stack
          direction="row"
          gap={0.5}
          justifyContent="flex-start"
          alignItems="center"
        >
          <Tooltip title={<ActionDescription />} placement="right" arrow>
            <span>
              Field Action
              <IconButton size="small">
                <InfoRounded />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </FormLabel>

      <RadioGroup onChange={handleChange} value={field.fieldAction} row>
        {options}
      </RadioGroup>
    </FormControl>
  )
}
